<p-dropdown [options]="unidades" [(ngModel)]="value"
    optionLabel="unidadeMedidaDeItemEmpresa.nome"
    [optionValue]="returnType === 'id' ? 'unidadeMedidaDeItemEmpresa.id' : undefined"
    [filter]="true" [filterBy]="'unidadeMedidaDeItemEmpresa.nome'" [showClear]="true"
    (onChange)="onSelect($event.value)" (onBlur)="onTouched()" [loading]="loading"
    scrollHeight="280px" appendTo="body" panelStyleClass="dropdown-panel-above-modal"
    [placeholder]="placeholder || ('select-unidade-medida.placeholder' | translate)">

    <ng-template let-unidade pTemplate="item">
        <div class="flex text-sm align-items-center">
            <div style="flex: 1;">{{ unidade.unidadeMedidaDeItemEmpresa?.nome }}</div>
        </div>
    </ng-template>

    <ng-template pTemplate="empty">
        <div class="p-2 text-center text-500">{{ 'select-unidade-medida.nenhuma_encontrada' | translate }}</div>
    </ng-template>

    <ng-template pTemplate="footer">
        <div *ngIf="showAddButton" class="unidade-add-item" role="button" tabindex="0" (mousedown)="onAddNew($event)">
            <div class="unidade-add-icon">
                <i class="pi pi-plus"></i>
            </div>
            <span class="unidade-add-label">{{ textoAgregarUnidade }}</span>
        </div>
    </ng-template>
</p-dropdown>

<!-- Dialog de nova unidade de medida -->
<app-unidade-adicionar-dialog
    [(visible)]="dialogVisible"
    (unidadeCriada)="onUnidadeCriada($event)">
</app-unidade-adicionar-dialog>
